module.exports = __webpack_public_path__ + "img/avatar0.97b89416.png";